import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';

const actions = {
  async getList({ commit }, { params }) {
    try {
      const result = await axios.get('/pay_settlement', { params });
      return result;
    } catch (err) {
      throw err;
    }
  },

  async erpReturnCreated({ commit }, { data, id }) {
    try {
      const result = await axios.put(`pay_settlement/erp_return_created/${id}`, { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async erpCnIssued({ commit }, { id }) {
    try {
      const result = await axios.put(`pay_settlement/erp_cn_issued/${id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async erpInvoiceSettled({ commit }, { id }) {
    try {
      const result = await axios.put(`pay_settlement/erp_invoice_settled/${id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getExcelHeader(_, {}) {
    try {
      const result = await axios({ url: 'pay_settlement/excel_header',
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'pay_settlement_bulk_upload.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async bulkUpload(_, { formData }) {
    try {
      const result = await axios.post('pay_settlement/bulk_upload/', formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async uploadStatus(_) {
    try {
      const result = await axios.get('/pay_settlement/upload_status');
      return result && result.data;
    } catch (err) {
      throw err;
    }
  },

  async getRejection(_, { transactionId }) {
    try {
      const result = await axios({ url: `pay_settlement/rejected/download?transcation_id=${transactionId}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'pay_settlement_rejections.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
